<template>
    <div class="HeaderTY-cmp">
		<div class="header-pc clearfix hidden-xs hidden-sm">
			<div class="logo">
				<a href="http://www.gdhhotels.com/index.html"><img src="../../assets/images/yh/icon/logo.png" ></a>
			</div>
			<div class="header-right-pc clearfix">
				<div class="nav">
					<ul>
						<li><a href="http://www.gdhhotels.com">首页</a></li>
						<li><a @click="searchHotel">查找酒店</a></li>
						<li><a href="http://www.gdhhotels.com/conference_banquet/conference_banquet.html" >会议与宴会</a></li>
						<li><a :href="this.$LoginUrl+'/?url='+ this.$ReturnUrl + '/jump-page'" >粤海荟</a></li>
<!--						-->
						<li><a href="http://www.gdhhotels.com/about/group-introduction.html" >集团介绍</a></li>
						<li><a href="http://booking.gdhhotels.com/auth/?url=http://booking.gdhhotels.com/pc/jump-page?from=order">我的订单</a></li>
					</ul>
				</div>
				<div style="float:left;margin-right: 30px;">
					<span class="leftLine"></span>
					<span class="tabLanguage" @click="showLanguage = ! showLanguage">语言</span>
					<el-collapse-transition>
						<ul class="yuyanTab" v-show="showLanguage">
							<li><a href="javascript:void(0);" @click="ZNurl">简体中文</a></li>
							<li><a href="javascript:void(0);" @click="ENurl">English</a></li>
						</ul>
					</el-collapse-transition>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				memberCenter: this.$LoginUrl+'?url='+this.$ReturnUrl+'/jump-page',
				mobileReg:/^0?(13[0-9]|15[012356789]|17[012356789]|18[0-9]|14[57]|19[9])[0-9]{8}$/,//手机号验证
				urlReg: /^\/pc/,
				showLanguage: false
			}
		},
		methods:{
			login(){
				location.href = this.$LoginUrl+"?url="+this.$ReturnUrl+"/jump-page"
			},
			toMemberCenter(){
			    window.location.href = this.$LoginUrl+'?url='+this.$ReturnUrl+'/jump-page'
			},
			searchHotel(){
				this.$router.push('/search-hotel');
			},
			ZNurl(){
				window.location.reload();
			},
			ENurl(){
				let url = window.location.pathname;
				if (this.urlReg.test(url)) {
					url = url.substring(3);
					if (window.location.search) {
						window.location.href = "http://" + window.location.host + "/enpc" + url + window.location.search;
					} else {
						window.location.href = "http://" + window.location.host + "/enpc" + url;
					}
				} else {
					window.location.reload();
				}
			},
		}
	}
</script>

<style scoped>
	@import "../../assets/css/hf_ty.css";
	label{
		font-size:12px;
		font-family:MicrosoftYaHei;
		color:#383635;
	}
	.input{
		height:54px;
		border:1px solid #dcdfe6;
		border-radius: 4px;
		width:97%;
		margin-top: 10px;
		margin-bottom: 20px;
		font-size:16px;
		padding-left:10px;
	}
	.search{
		width:100%;
		margin-top: 5px;
		height:54px;
		font-size:16px;
		line-height:54px;
	}
	.login{
		width:100%;
		margin-top: 20px;
		height:54px;
		font-size:16px;
		margin-left:0px;
		line-height:54px;
	}
	.nav ul li a{
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// HeaderYH.vue?09d7a45d